import React, { FC, ReactNode } from "react";
import CloseIcon from "../../icons/Close";
import ArrowLeftIcon from "../../icons/ArrowLeft";
import ExpandIcon from "../../icons/Expand";

interface AppDrawerProps {
  show: boolean;
  title?: string | ReactNode;
  onClose: () => void;
  children?: ReactNode;
  className?: string;
  width?: string;
  expand?: boolean;
  onExpand?: () => void;
  isBooking?: boolean;

}

const AppDrawer: FC<AppDrawerProps> = ({
  show,
  title,
  onClose,
  children,
  className="",
  width ="",
  expand= false,
  onExpand,
  isBooking =false
}) => {
  return (
    <>
      {show && (
        <button
          className="fixed z-100 top-0 left-0 h-screen w-full glassy  bg-white "
          onClick={onClose}
          aria-label="Close Drawer"
          style={{ cursor: "pointer" }}
        ></button>
      )}
      <div
        className={`fixed z-100 right-0 top-0 w-1/4 md:min-w-[650px]  min-w-[360px]  ${width} h-screen overflow-y-auto border border-slate-200 bg-white transition-transform duration-300 ${show ? "drawer-enter-active" : "drawer-exit-active"}`}
        data-testid="AppDrawer"
      >
        <div className="sticky top-0 z-10 flex items-center justify-between p-4 bg-white border-b border-slate-200">

          {title && (
            <h2 className={`text-xl font-medium text-slate-600 ${className}`} >
              {title}
            </h2>
          )}
          {title ? (
            <>

              {isBooking && expand ? (
                <button
                  className="cursor-pointer text-slate-600"
                  onClick={onExpand}
                  aria-label="Expand"
                >
                  <ExpandIcon size={20}  />
                </button>
              )
                : (
                  <button onClick={onClose}    className="bg-transparent">
                    <CloseIcon
                      size="sm"
                      color="slate"
                    />
                  </button>

                )}

            </>
          ) : (
            <div className="flex items-center w-full justify-between">
              <ArrowLeftIcon
                className="hover:cursor-pointer"
                onClick={onClose}
              />
              {expand && (
                <button
                  className="cursor-pointer text-slate-600"
                  onClick={onExpand}
                  aria-label="Expand"
                >
                  <ExpandIcon size={20} />
                </button>
              )}
            </div>
          )}


        </div>
        <div className={`p-2 ${title ? "pt-4" : ""}`}>{children}</div>
      </div>
    </>
  );
};

export default AppDrawer;
